import { render, staticRenderFns } from "./ModelTreeVK.vue?vue&type=template&id=c63a742a&scoped=true"
import script from "./ModelTreeVK.vue?vue&type=script&lang=js"
export * from "./ModelTreeVK.vue?vue&type=script&lang=js"
import style0 from "./ModelTreeVK.vue?vue&type=style&index=0&id=c63a742a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63a742a",
  null
  
)

export default component.exports